import React, { Component } from "react";

export default class FullStackImg extends Component {
  render() {
    const theme = this.props.theme;
    const primary = theme.imageHighlight || "#0E6BA8";
    const accent = theme.headerColor || "#0E6BA877";
    const surface = theme.body || "#ffffff";
    const ink = theme.text || "#001C55";

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80%"
        height="auto"
        viewBox="0 0 500 400"
        fill="none"
        aria-label="Modular SDK architecture"
      >
        <ellipse cx="250" cy="370" rx="180" ry="14" fill={accent} opacity="0.4" />

        {/* Layered modular SDK stack — isometric */}
        <g transform="translate(250,210)">
          {/* layer 5 - top (UI) */}
          <g transform="translate(0,-100)">
            <polygon
              points="0,-30 110,-3 0,24 -110,-3"
              fill={primary}
              opacity="0.95"
            />
            <text
              x="0"
              y="3"
              textAnchor="middle"
              fontSize="11"
              fontFamily="Helvetica, sans-serif"
              fontWeight="700"
              fill={surface}
            >
              UI / SwiftUI
            </text>
          </g>
          {/* layer 4 (Feature SDK) */}
          <g transform="translate(0,-50)">
            <polygon
              points="0,-30 110,-3 0,24 -110,-3"
              fill={primary}
              opacity="0.78"
            />
            <text
              x="0"
              y="3"
              textAnchor="middle"
              fontSize="11"
              fontFamily="Helvetica, sans-serif"
              fontWeight="700"
              fill={surface}
            >
              Feature SDKs
            </text>
          </g>
          {/* layer 3 (Domain) */}
          <g transform="translate(0,0)">
            <polygon
              points="0,-30 110,-3 0,24 -110,-3"
              fill={primary}
              opacity="0.62"
            />
            <text
              x="0"
              y="3"
              textAnchor="middle"
              fontSize="11"
              fontFamily="Helvetica, sans-serif"
              fontWeight="700"
              fill={surface}
            >
              Domain / Core
            </text>
          </g>
          {/* layer 2 (Networking) */}
          <g transform="translate(0,50)">
            <polygon
              points="0,-30 110,-3 0,24 -110,-3"
              fill={primary}
              opacity="0.46"
            />
            <text
              x="0"
              y="3"
              textAnchor="middle"
              fontSize="11"
              fontFamily="Helvetica, sans-serif"
              fontWeight="700"
              fill={ink}
            >
              Network · Persistence
            </text>
          </g>
          {/* layer 1 - bottom (Foundation) */}
          <g transform="translate(0,100)">
            <polygon
              points="0,-30 110,-3 0,24 -110,-3"
              fill={primary}
              opacity="0.3"
            />
            <text
              x="0"
              y="3"
              textAnchor="middle"
              fontSize="11"
              fontFamily="Helvetica, sans-serif"
              fontWeight="700"
              fill={ink}
            >
              Foundation
            </text>
          </g>
        </g>

        {/* Interconnect dots showing modules wire-up */}
        <g opacity="0.7">
          <circle cx="370" cy="120" r="6" fill={primary} />
          <circle cx="380" cy="170" r="6" fill={primary} />
          <circle cx="370" cy="220" r="6" fill={primary} />
          <line x1="370" y1="120" x2="380" y2="170" stroke={primary} strokeWidth="2" />
          <line x1="380" y1="170" x2="370" y2="220" stroke={primary} strokeWidth="2" />
        </g>
        <g opacity="0.7">
          <circle cx="120" cy="120" r="6" fill={primary} />
          <circle cx="110" cy="170" r="6" fill={primary} />
          <circle cx="120" cy="220" r="6" fill={primary} />
          <line x1="120" y1="120" x2="110" y2="170" stroke={primary} strokeWidth="2" />
          <line x1="110" y1="170" x2="120" y2="220" stroke={primary} strokeWidth="2" />
        </g>

        {/* small badge: 99% crash-free */}
        <g transform="translate(60,60)">
          <rect width="100" height="34" rx="17" fill={primary} />
          <text
            x="50"
            y="22"
            textAnchor="middle"
            fontSize="13"
            fontFamily="Helvetica, sans-serif"
            fontWeight="700"
            fill={surface}
          >
            99% crash-free
          </text>
        </g>
      </svg>
    );
  }
}
